export const Constants = {
    SET_LOGIN_DATA: 'SET_LOGIN_DATA',
    SET_LOGOUT: 'SET_LOGOUT',
    SET_URL: 'SET_URL',
    ADD_FOOD_TO_CART: 'ADD_FOOD_TO_CART',
    ADD_REST_DETAILS: 'ADD_REST_DETAILS',
    EMPTY_FOOD_FROM_CART: 'EMPTY_FOOD_FROM_CART'
}